<template>
  <div class="ds-control mobile dsf_teas_staff_wubie">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length > 0">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" @load="getList">
        <div class="list">
          <!-- <div class="list-item" v-for="(item, index) in list" :key="index">
            <div class="date">{{ item.dateTime }} {{ item.weekStr }}</div>
            <div
              class="atten-item"
              v-for="(classItem, index) in item.classNoons"
              :key="index"
              @click="detail(classItem)"
            >
              <div class="row">
                <div class="time flex-sub">{{ classItem.noonText }}</div>
                <div class="row-middle">
                  应到 <span class="text-black">{{ classItem.shouldArrive }}</span>人
                </div>
                <div class="flex-sub text-right">
                  考勤率
                  <span class="text-blue">{{ classItem.attendanceRate }}</span>
                </div>
              </div>
              <div class="row">
                <div class="flex-sub">
                  出勤
                  <span class="text-green">{{ classItem.attendanceNum }}</span>人
                </div>
                <div class="row-middle">
                  请假 <span class="text-blue">{{ classItem.leaveNum }}</span>人
                </div>
                <div class="flex-sub text-right">
                  未签 <span class="text-red">{{ classItem.notSign }}</span>人
                </div>
              </div>
              <div class="row">
                <div class="flex-sub">
                  迟到
                  <span class="text-red">{{ classItem.late }}</span>人
                </div>
                <div class="row-middle">
                  晚到 <span class="text-red">{{ classItem.seriousLate }}</span>人
                </div>
                <div class="flex-sub text-right">
                  早退 <span class="text-red">{{ classItem.early }}</span>人
                </div>
              </div>
            </div>
          </div> -->
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <div class="item_date">{{ item.dateTime }} {{ item.weekStr }}</div>
            <div class="atten_item" v-for="(classItem, index) in item.classNoons" :key="index" @click="detail(classItem)">
              <div class="time">
                <span>{{classItem.noonText}}</span>(应到: {{classItem.shouldArrive}}人 考勤率:{{ classItem.attendanceRate }})
              </div>
              <div class="row_item">
                <div v-if="systemArr.includes('1')">
                  出勤: <span :class="classItem.attendanceNum?'text_green':''">{{classItem.attendanceNum}}</span> 人
                </div>
                <div v-if="systemArr.includes('2')">
                  迟到: <span :class="classItem.late?'text_red':''">{{classItem.late}}</span> 人
                </div>
                <div v-if="systemArr.includes('3')">
                  晚到: <span :class="classItem.seriousLate?'text_red':''">{{classItem.seriousLate}}</span> 人
                </div>
                <div>
                  请假: <span :class="classItem.leaveNum?'text_blue':''">{{classItem.leaveNum}}</span> 人
                </div>
                <div v-if="systemArr.includes('4')">
                  早退: <span :class="classItem.early?'text_red':''">{{classItem.early}}</span> 人
                </div>
                <div>
                  未签: <span :class="classItem.notSign?'text_red':''">{{classItem.notSign}}</span> 人
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-empty v-else description="暂无数据" />
  </div>
</template>

<script>
const testData = [
  {
    dateTime: "2021-02-28",
    weekStr: "星期日",
    classNoons: [
      {
        attendanceNoonId: "4142b959dcad42f7a7be59a8b7b2702a",
        noonText: "上午",
        noonValue: "1",
        shouldArrive: "2",
        attendanceRate: "0.00%",
        attendanceNum: "0",
        abnormalNum: "2",
        leaveNum: "0",
      },
    ],
  },
  {
    dateTime: "2021-02-27",
    weekStr: "星期六",
    classNoons: [
      {
        attendanceNoonId: "6edce76212f54048bc8298c41f4f5dae",
        noonText: "上午",
        noonValue: "1",
        shouldArrive: "2",
        attendanceRate: "0.00%",
        attendanceNum: "0",
        abnormalNum: "2",
        leaveNum: "0",
      },
    ],
  },
];
export default dsf.component({
  name: "DsfMobileTeasStaffWubie",
  mixins: [$mixins.control],
  ctrlCaption: "班次午别考勤-班主任",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "/teas/attendance/classNoonInfo",
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pageNum: 0,
      classId: "",
      list: [],
      systemArr: [],
    };
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.classId = this.$route.query.classId;
      this.getList();
      this.getSystem();
    }
  },
  activated: function () {
    this.onRefresh();
  },
  methods: {
    detail(item) {
      console.log(item)
      this.$router.push('/mobile/teas/attendance/mobile/kqxq?classId=' + this.classId + '&relId=' + item.attendanceNoonId + '&elective=' + this.queryString.elective + '&isGroup='+item.isGroupValue)
    },
    // 获取列表数据
    getList(isRefresh = false) {
      const loading = dsf.layer.loading();
      this.pageNum++;
      this.$http
        .post(this.$replace(this.sourcesUrl, this), {
          pageNum: this.pageNum,
          classId: this.classId,
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (isRefresh) {
              this.list = res.data.list
            } else {
              this.list.push(...res.data.list);
            }
            this.finished = res.data.lastPage;
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true;
        })
        .always(() => {
          this.loading = false;
          this.refreshing = false
          dsf.layer.closeLoading(loading);
        });
    },
    getSystem() {
      this.$http.get('teas/attendance/getSystemAttendRules', {}).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.systemArr = res.data.split('^')
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
        });
    },
    // 刷新
    onRefresh() {
      this.pageNum = 0;
      this.getList(true);
      this.getSystem();
    },
  },
});
</script>